import {
  ClientOrderControllerGetOrdersApiArg,
  ClientOrderControllerGetOrderByIdApiArg,
  ClientOrderControllerGetOrdersApiResponse,
  ClientOrderControllerGetOrderByIdApiResponse,
  ClientOrderControllerCreateTakeoutOrderApiArg,
  ClientOrderControllerCreateCitywideDeliveryApiArg,
  ClientOrderControllerCreateTakeoutOrderApiResponse,
  ClientOrderControllerCreateNationwideDeliveryApiArg,
  ClientOrderControllerCreateOrderFromOrderPointApiArg,
  ClientOrderControllerCreateCitywideDeliveryApiResponse,
  ClientOrderControllerCreateNationwideDeliveryApiResponse,
  ClientOrderControllerCreateOrderFromOrderPointApiResponse,
} from '@/app/store/api/restApi';
import { emptyApi } from '@/app/store/api/emptyApi';

export const ordersApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getOrders: build.query<ClientOrderControllerGetOrdersApiResponse, ClientOrderControllerGetOrdersApiArg>({
      query: ({ limit, cursor }) => ({ url: `orders`, params: { limit, cursor } }),
    }),

    getOrderById: build.query<ClientOrderControllerGetOrderByIdApiResponse, ClientOrderControllerGetOrderByIdApiArg>({
      query: ({ id }) => `orders/${id}`,
      keepUnusedDataFor: 0,
    }),

    createTakeoutOrder: build.mutation<
      ClientOrderControllerCreateTakeoutOrderApiResponse,
      ClientOrderControllerCreateTakeoutOrderApiArg
    >({
      query: ({ createTakeoutOrderDto }) => ({ url: 'orders/takeout', method: 'POST', body: createTakeoutOrderDto }),
      invalidatesTags: ['Orders'],
      extraOptions: { maxRetries: 0 },
    }),

    createCitywideDeliveryOrder: build.mutation<
      ClientOrderControllerCreateCitywideDeliveryApiResponse,
      ClientOrderControllerCreateCitywideDeliveryApiArg
    >({
      query: ({ createDeliveryOrderCitywideDto }) => ({
        method: 'POST',
        url: 'orders/delivery',
        body: createDeliveryOrderCitywideDto,
      }),
      invalidatesTags: ['Orders'],
      extraOptions: { maxRetries: 0 },
    }),

    createNationwideDeliveryOrder: build.mutation<
      ClientOrderControllerCreateNationwideDeliveryApiResponse,
      ClientOrderControllerCreateNationwideDeliveryApiArg
    >({
      query: ({ createDeliveryOrderNationwideDto }) => ({
        method: 'POST',
        url: 'orders/delivery/nationwide',
        body: createDeliveryOrderNationwideDto,
      }),
      invalidatesTags: ['Orders'],
      extraOptions: { maxRetries: 0 },
    }),

    createOrderPointDeliveryOrder: build.mutation<
      ClientOrderControllerCreateOrderFromOrderPointApiResponse,
      ClientOrderControllerCreateOrderFromOrderPointApiArg
    >({
      query: (queryArg) => ({
        url: `orders/order-point`,
        method: 'POST',
        body: queryArg.createOrderFromOrderPoint,
      }),
    }),
  }),
});

export const {
  useLazyGetOrdersQuery,
  useLazyGetOrderByIdQuery,
  useCreateTakeoutOrderMutation,
  useCreateCitywideDeliveryOrderMutation,
  useCreateNationwideDeliveryOrderMutation,
  useCreateOrderPointDeliveryOrderMutation,
} = ordersApi;
